import Component from 'vue-class-component'
import PreviewComponentVue from './PreviewComponent'
import { EmbedData } from '../../store/editor/components/state'

@Component
export default class EmbedVue extends PreviewComponentVue<EmbedData> {

  get content(): string {
    return this.componentData.content
  }
}
